<ng-container *ngIf="control">
  <div
    class="floating-label"
    [ngClass]="control.invalid && control.touched ? 'error' : ''">
    <input
      (change)="onChooseDocument($event)"
      type="file"
      [name]="inputData?.key"
      [id]="inputData?.key"
      class="floating-input"
      [formControl]="control" />
    <label [for]="inputData?.key">{{ inputData?.label }}</label>
  </div>
</ng-container>
